import auth from 'src/router/middleware/authentification/auth.js'
import recentAuth from 'src/router/middleware/authentification/recentAuth.js'
import classbookRedirect from 'src/router/middleware/classbook/classbookRedirect.js'

import { ENTITY_TYPE } from 'src/config/constants.ts'
import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

const ClassbookWrapper = () => import('src/views/Classbook/ClassbookWrapper.vue')
const ClassbookEntityList = () => import('src/views/Classbook/ClassbookEntityList.vue')
const UsersWrapper = () => import('src/views/Classbook/Users/UsersWrapper.vue')
const ClassbookEntityEntriesWrapper = () => import('src/views/Classbook/ClassbookEntityEntriesWrapper.vue')
const AbsencesWrapper = () => import('src/views/Classbook/Absences/AbsencesWrapper.vue')
const StatisticsWrapper = () => import('src/views/Classbook/Statistics/StatisticsWrapper.vue')
const ChronicWrapper = () => import('src/views/Classbook/Chronic/ChronicWrapper.vue')
const NoticesWrapper = () => import('src/views/Classbook/Notices/NoticesWrapper.vue')
const HomeworksWrapper = () => import('src/views/Classbook/Homework/HomeworksWrapper.vue')

const getDCOverviewRouteName = (route) => {
  const entity = route.params.entity
  const entityId = route.params.id

  if (!entity) return `${route.name}`

  const isSelf = GlobalPrototypes.store.getters['users/me'].id === entityId
  if (isSelf) return `${route.name}-self`

  const isAllTab = [ENTITY_TYPE.allCourses, ENTITY_TYPE.allUsers, ENTITY_TYPE.allGrades].includes(entityId)
  if (isAllTab) return `${route.name}-all`

  return `${route.name}-${entity}`
}

export default [
  {
    path: '/classbooks/:classbook/overview/',
    component: ClassbookWrapper,
    name: 'classbook-overview',
    meta: {
      middleware: [auth, recentAuth, classbookRedirect],
      enableSwReload: true,
      headerText: 'global.headers.dc'
    },
    children: [
      {
        path: ':entity?/details/:id?',
        name: 'classbook-entity-details',
        component: ClassbookEntityList,
        meta: {
          middleware: [auth, recentAuth, classbookRedirect],
          routeNameForTracking: getDCOverviewRouteName,
          headerText: 'global.headers.dc'
        },
        children: [
          {
            path: 'users',
            name: 'classbook-entity-details-users',
            component: UsersWrapper,
            meta: {
              middleware: [auth, recentAuth, classbookRedirect],
              can: 'view-members',
              routeNameForTracking: getDCOverviewRouteName,
              headerText: 'global.headers.dc'
            }
          },
          {
            path: 'entries',
            name: 'classbook-entity-details-entries',
            redirect: { name: 'classbook-entity-entries-classes' },
            component: ClassbookEntityEntriesWrapper,
            meta: {
              middleware: [auth, recentAuth, classbookRedirect],
              can: 'view-entries',
              routeNameForTracking: getDCOverviewRouteName,
              headerText: 'global.headers.dc'
            },
            children: [
              {
                path: 'entries',
                name: 'classbook-entity-entries-classes',
                component: ChronicWrapper,
                meta: {
                  middleware: [auth, recentAuth, classbookRedirect],
                  can: 'view-entries',
                  routeNameForTracking: getDCOverviewRouteName,
                  headerText: 'global.headers.dc'
                }
              },
              {
                path: 'notices',
                name: 'classbook-entity-entries-comments',
                component: NoticesWrapper,
                meta: {
                  middleware: [auth, recentAuth, classbookRedirect],
                  can: 'view-notices',
                  routeNameForTracking: getDCOverviewRouteName,
                  headerText: 'global.headers.dc'
                }
              },
              {
                path: 'homework',
                name: 'classbook-entity-entries-homework',
                component: HomeworksWrapper,
                meta: {
                  middleware: [auth, recentAuth, classbookRedirect],
                  can: 'view-homeworks',
                  routeNameForTracking: getDCOverviewRouteName,
                  headerText: 'global.headers.dc'
                }
              }
            ]
          },
          {
            path: 'statistics',
            name: 'classbook-entity-details-statistics',
            component: StatisticsWrapper,
            meta: {
              middleware: [auth, recentAuth, classbookRedirect],
              can: 'view-statistics',
              routeNameForTracking: getDCOverviewRouteName,
              headerText: 'global.headers.dc'
            }
          },
          {
            path: 'absences',
            name: 'classbook-entity-details-absences',
            component: AbsencesWrapper,
            meta: {
              middleware: [auth, recentAuth, classbookRedirect],
              can: 'view-absences',
              routeNameForTracking: getDCOverviewRouteName,
              headerText: 'global.headers.dc'
            }
          }
        ]
      }
    ]
  }
]
